import { BuyCloudOrgSetupPageTemplate } from "../../../../templates/buy/cloud/org-setup/src/buy-cloud-org-setup-page.template";

export const BuyCloudOrgSetupPage = () => <BuyCloudOrgSetupPageTemplate />;
